import React from 'react';
import { Trans } from '@lingui/macro';

import { LogoTypeFa } from '@src/components/icons';
import VisibleStatusBar from '@src/components/VisibleStatusBar';

import {
  Background,
  CenterContainer,
  ContainButton,
  Container,
  Content,
  Footer,
  Gradient,
  GradientText,
} from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = ({ navigation }) => {
  const handleSignUpPress = React.useCallback(
    () => requestAnimationFrame(() => navigation.navigate('SignUpPhone')),
    [navigation]
  );
  const handleSignInPress = React.useCallback(
    () => requestAnimationFrame(() => navigation.navigate('SignIn')),
    [navigation]
  );

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <Background source={require('./welcome.jpg')} resizeMode="contain">
          <Gradient
            locations={[0.67, 1]}
            colors={['rgba(0,0,0,0.24)', '#F2F2F2']}
          />
        </Background>
        <Content>
          <CenterContainer>
            <LogoTypeFa width={170} height={170} />
            <GradientText>
              <Trans>Welcome to the world of pro travelers!</Trans>
            </GradientText>
            <ContainButton preset="secondary" onPress={handleSignUpPress}>
              <Trans>Sign Up</Trans>
            </ContainButton>
            <ContainButton onPress={handleSignInPress}>
              <Trans>Login</Trans>
            </ContainButton>
            <Footer />
          </CenterContainer>
        </Content>
      </Container>
    </>
  );
};

Screen.displayName = 'Authentication';

export default Screen;
